import React, { useState, useEffect } from "react";
import moment from "moment";
import config from "config.json";

import { Link } from "react-router-dom";
import Popup from "reactjs-popup";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { getGames } from "services/game_service";
import GameCard from "./team/gameCard";
import 'moment/locale/pt'
moment.locale('pt')

function App() {
  const [gamesList, setGamesList] = useState([]);
  const [previousGamesList, setPreviousGamesList] = useState([]);
  const [nextGame, setNextGame] = useState(null);
  const [teamName, setTeamName] = useState(null);

  useEffect(() => {
    async function fetchData() {
      //TODO ADD HERE IN THE FUTURE THE SELECTED TEAM MUST BE IN A TEAM ID
      console.log("fetch DATA");
      let games = await getGames({
        date: { $gte: moment().format(config.STRAPI_DATETIME_FORMAT) },
      });

      games.sort((a, b) => {
        return new Date(a.attributes.date) - new Date(b.attributes.date);
      });
      setGamesList(games);

      let prevGames = await getGames({
        date: { $lte: moment().format(config.STRAPI_DATETIME_FORMAT) },
      });

      prevGames.sort((a, b) => {
        return new Date(a.attributes.date) - new Date(b.attributes.date);
      });
      setPreviousGamesList(prevGames);

      let nextGame = await getGames(
        {
          date: { $gte: moment().format(config.STRAPI_DATETIME_FORMAT) },
        },
        "sort[0]=date"
      );

      setNextGame(nextGame && nextGame.length > 0 ? nextGame[0] : null);

      if (nextGame && nextGame.length > 0) {
        let team = JSON.parse(localStorage.getItem("teamIDs")).find(
          (c) => c.id === nextGame[0].attributes.team.data.id
        );
        setTeamName(team.label);
      }
    }

    fetchData();
  }, []);

  const canEditGame = () => {
    if (
      localStorage.getItem("role") === "Treinador" ||
      localStorage.getItem("role") === "Clube"
    ) {
      return true;
    }

    return false;
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/equipas"}>Jogos</Link>
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Jogos</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="columns credencial-style">
              <div className="column is-full exist">
                {nextGame && (
                  <div style={{ maxWidth: "350px" }}>
                    <p className="bold">PRÓXIMO JOGO</p>
                    <GameCard
                      homeTeamName={
                        nextGame.attributes.location === "home"
                          ? teamName
                          : nextGame.attributes.opponent
                      }
                      homeTeamLogo={
                        nextGame.attributes.location === "home"
                          ? localStorage.getItem("clube_logo")
                          : undefined
                      }
                      awayTeamName={
                        nextGame.attributes.location === "home"
                          ? nextGame.attributes.opponent
                          : teamName
                      }
                      awayTeamLogo={
                        nextGame.attributes.location === "home"
                          ? undefined
                          : localStorage.getItem("clube_logo")
                      }
                      gameDate={moment(nextGame.attributes.date)}
                      score={
                        nextGame.attributes.home_team_goals
                          ? nextGame.attributes.home_team_goals +
                            "-" +
                            nextGame.attributes.home_team_goals
                          : undefined
                      }
                    ></GameCard>
                  </div>
                )}
                <br></br>
              </div>
            </div>
            <div className="columns credencial-style">
              <div className="column is-full exist">
                <p className="bold">CALENDÁRIO</p>
                <br></br>
                <>
                  <table className="table fullwidth">
                    <thead>
                      <tr>
                        <th style={{ width: "18%" }}>
                          <abbr title="Position">Próximos Jogos</abbr>
                        </th>
                        {localStorage.getItem("role") === "Clube" && (
                          <th style={{ width: "18%" }}>
                            <abbr title="Position">Escalão</abbr>
                          </th>
                        )}
                        <th style={{ width: "18%" }}>
                          <abbr title="Played">Competição</abbr>
                        </th>
                        <th style={{ width: "18%" }}>
                          <abbr title="Won">Data</abbr>
                        </th>
                        <th style={{ width: "18%" }}>
                          <abbr title="Drawn">Resultado</abbr>
                        </th>
                        <th style={{ width: "10%" }}>
                          <abbr title="Drawn">Ações</abbr>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {gamesList.map((game) => (
                        <tr>
                          <td>{"vs " + game.attributes.opponent}</td>

                          {localStorage.getItem("role") === "Clube" && (
                            <td>
                              {game?.attributes?.team?.data?.attributes?.level
                                ? game.attributes.team.data.attributes.level
                                : ""}
                            </td>
                          )}
                          <td>{game.attributes.competition}</td>
                          <td>
                            {game.attributes.date
                              ? moment(game.attributes.date).format(
                                  "DD-MM-YYYY - HH:mm"
                                )
                              : ""}
                          </td>
                          <td>
                            {Number.isInteger(
                              game.attributes.home_team_goals
                            ) &&
                            Number.isInteger(game.attributes.away_team_goals)
                              ? game.attributes.home_team_goals +
                                " - " +
                                game.attributes.away_team_goals
                              : ""}
                          </td>
                          <td>
                            <Popup
                              trigger={<i className="fa fa-ellipsis-v"></i>}
                              position="left center"
                            >
                              <div className="dropdown-content">
                                <Link
                                  className="dropdown-item"
                                  to={`/jogos/${game.id}`}
                                >
                                  Detalhe do Jogo
                                </Link>
                                {canEditGame() && (
                                  <Link
                                    className="dropdown-item"
                                    to={`/jogos/${game.id}/apagar`}
                                  >
                                    Apagar o jogo
                                  </Link>
                                )}
                              </div>
                            </Popup>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
                {canEditGame() && (
                  <div className="flex fullWidth">
                    <Link to={`/equipa/3/novo-jogo`} className="marginAuto">
                      <i className="fa fa-plus circled-icon"></i>
                    </Link>
                  </div>
                )}
              </div>
            </div>

            <div className="columns credencial-style">
              <div className="column is-full exist">
                <p className="bold">HISTÓRICO</p>
                <table className="table fullwidth">
                  <thead>
                    <tr>
                      <th style={{ width: "18%" }}>
                        <abbr title="Position">Últimos Jogos</abbr>
                      </th>
                      {localStorage.getItem("role") === "Clube" && (
                        <th style={{ width: "18%" }}>
                          <abbr title="Position">Escalão</abbr>
                        </th>
                      )}
                      <th style={{ width: "18%" }}>
                        <abbr title="Played">Competição</abbr>
                      </th>
                      <th style={{ width: "18%" }}>
                        <abbr title="Won">Data</abbr>
                      </th>
                      <th style={{ width: "18%" }}>
                        <abbr title="Drawn">Resultado</abbr>
                      </th>
                      <th style={{ width: "10%" }}>
                        <abbr title="Drawn">Ações</abbr>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {previousGamesList.map((game) => (
                      <tr>
                        <td>{"vs  " + game.attributes.opponent}</td>
                        {localStorage.getItem("role") === "Clube" && (
                          <td>
                            {game?.attributes?.team?.data?.attributes?.level
                              ? game.attributes.team.data.attributes.level
                              : ""}
                          </td>
                        )}
                        <td>{game.attributes.competition}</td>
                        <td>
                          {game.attributes.date
                            ? moment(game.attributes.date).format(
                                "DD-MM-YYYY - HH:mm"
                              )
                            : ""}
                        </td>
                        <td>
                          {Number.isInteger(game.attributes.home_team_goals) &&
                          Number.isInteger(game.attributes.away_team_goals)
                            ? game.attributes.home_team_goals +
                              " - " +
                              game.attributes.away_team_goals
                            : ""}
                        </td>
                        <td>
                          <Popup
                            trigger={<i className="fa fa-ellipsis-v"></i>}
                            position="left center"
                          >
                            <div className="dropdown-content">
                              <Link
                                className="dropdown-item"
                                to={`/jogos/${game.id}`}
                              >
                                Detalhe do Jogo
                              </Link>
                              {canEditGame() && (
                                <Link
                                  className="dropdown-item"
                                  to={`/jogos/${game.id}/apagar`}
                                >
                                  Apagar o jogo
                                </Link>
                              )}
                            </div>
                          </Popup>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
